import moment from 'moment-timezone'
import * as yup from 'yup'

const validationSchema = yup.object().shape({
  clinicalHistoryDescription: yup
    .string()
    .typeError('Campo obrigatório')
    .required()
    .max(5000, 'Máximo 5000 caracteres'),
  clinicalHistoryAspects: yup
    .string()
    .typeError('Campo obrigatório')
    .required()
    .max(5000, 'Máximo 5000 caracteres'),
  clinicalHistoryLatexAllergy: yup.string().required(),
  clinicalHistoryOtherAllergy: yup.string().max(500, 'Máximo 500 caracteres'),
  clinicalHistoryOncology: yup
    .boolean()
    .typeError('Campo obrigatório')
    .required(),
  clinicalHistoryBloodTransfusion: yup
    .boolean()
    .typeError('Campo obrigatório')
    .required(),
  clinicalHistoryTechnique: yup
    .string()
    .typeError('Campo obrigatório')
    .required(),
  clinicalHistoryCongelation: yup
    .boolean()
    .typeError('Campo obrigatório')
    .required(),
  clinicalHistoryBloodReserve: yup
    .boolean()
    .typeError('Campo obrigatório')
    .required(),
  clinicalHistoryHospitalized: yup.boolean().nullable(),
  clinicalHistoryExpectedDate: yup
    .date()
    .typeError('Data inválida')
    .nullable()
    .optional()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .test(
      'greater_then_today',
      'A data informada não pode ser menor que a atual.',
      (value) => {
        if (value) {
          const date = moment(value).startOf('day')
          const now = moment().startOf('day')
          return date.isValid() && date >= now
        }
        return true
      }
    )
    .test(
      'less_then_one_year',
      'A data informada não pode ser maior que 1 ano a partir da data atual.',
      (value) => {
        if (value) {
          const date = moment(value).startOf('day')
          const oneYearFromNow = moment().add(1, 'year').startOf('day')
          return date.isValid() && date <= oneYearFromNow
        }
        return true
      }
    )
    .when('clinicalHistoryHospitalizationType', {
      is: 'urgency',
      then: (schema) => schema.required()
    }),
  clinicalHistoryBullishForecastDate: yup
    .date()
    .typeError('Data inválida')
    .nullable()
    .optional()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .test(
      'greater_then_today',
      'A data informada não pode ser menor que a atual.',
      (value) => {
        if (value) {
          const date = moment(value).startOf('day')
          const now = moment().startOf('day')
          return date.isValid() && date >= now
        }
        return true
      }
    ),
  clinicalHistoryHospitalizationType: yup
    .string()
    .typeError('Campo obrigatório')
    .required(),
  clinicalHistoryHospitalizationMode: yup
    .string()
    .typeError('Campo obrigatório')
    .required(),
  clinicalHistoryHospitalizationDailyQuantity: yup
    .number()
    .typeError('Campo obrigatório')
    .required()
    .when('clinicalHistoryHospitalizationMode', {
      is: 'ambulatory',
      then: (schema) => schema.min(0, 'Mínimo 0 dias'),
      otherwise: (schema) => schema.min(1, 'Mínimo 1 dia')
    }),
  clinicalHistoryCti: yup.boolean().typeError('Campo obrigatório').required(),
  clinicalHistoryMedicalObservations: yup
    .string()
    .typeError('Campo obrigatório')
    .required()
    .max(5000, 'Máximo 5000 caracteres')
})

export default validationSchema
